module.exports = __webpack_public_path__ + "assets/img/17_991_big.cb90a7be.jpg";